import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom"; // Import Link from react-router-dom

const validImageTypes = ["jpg", "jpeg", "png", "gif", "bmp", "svg"];

const isValidImageFile = (file) => {
  return (
    file &&
    file instanceof File &&
    validImageTypes.includes(file.type.split("/").pop())
  );
};

const ImageViewer = ({ imageName }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [imageURL, setImageURL] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/view-file.php?fileName=${imageName}`,
          {
            responseType: "blob", // Important for image downloads
          }
        );

        // Create a URL for the image
        const imageURL = URL.createObjectURL(response.data);
        setImageURL(imageURL); // Set the image URL in state
      } catch (error) {
        console.error("Error fetching the image:", error);
        setError("Failed to fetch image."); // Set error in state
      } finally {
        setLoading(false); // Update loading state
      }
    };

    if (typeof imageName === "string") {
      fetchImage(); // Call the fetch function
    } else if (isValidImageFile(imageName)) {
      const imageURL = URL.createObjectURL(imageName);
      setImageURL(imageURL);
      setLoading(false);
    } else {
      setLoading(false);
      setError("Invalid image file.");
    }
  }, [imageName]);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const handleOverlayClick = (e) => {
    // Close the modal only if the overlay is clicked
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  if (loading) {
    return <div>Loading image...</div>; // Show loading message
  }

  if (error) {
    return <div>Error: {error}</div>; // Show error message
  }

  return (
    <div className="pb-4">
      {imageURL ? (
        <div className="relative">
          <img
            src={imageURL}
            alt={imageName}
            className="object-cover cursor-pointer  transition-transform transform hover:scale-105"
            onClick={openModal}
          />
          {isOpen && (
            <div
              className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
              onClick={handleOverlayClick} // Add click handler here
            >
              <div className="relative max-w-[80vw] max-h-[80vh]">
                <img
                  src={imageURL}
                  alt={imageName}
                  className="w-full h-full object-contain"
                  style={{
                    maxWidth: "80vw",
                    maxHeight: "80vh",
                  }}
                />
                <Link
                  to="#"
                  className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full bg-orange-600 text-white "
                  onClick={(e) => {
                    e.preventDefault(); // Prevent default link behavior
                    closeModal();
                  }}
                >
                  &times;
                </Link>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div>No image available</div>
      )}
    </div>
  );
};

export default ImageViewer;
